module.exports = __webpack_public_path__ + "static/media/Mcs_HI_maps.d3d4b38e.jpg";